// Same names as in secrets repository
export const DEFAULT_FEATURE_FLAGS = {
  ArbolusGpt: false,
  FeatureFlagOverride: false,
  ProjectCreationV3: false,
  MicrosoftAppleSSO: false,
  WebinarBanner: false,
  ExpertDashboard: false,
  ExpertOnboarding: false
} as const;

// Unfortunately "FeatureFlags" is already taken by the "flagged" library
// in this way we'll avoid wrong auto imports
export type ArbolusFeatureFlags = typeof DEFAULT_FEATURE_FLAGS;

export type ArbolusFeatureFlag = keyof typeof DEFAULT_FEATURE_FLAGS;

// String representation
export const FEATURE_FLAGS = Object.fromEntries(
  Object.keys(DEFAULT_FEATURE_FLAGS).map((key) => [key, key])
) as Record<ArbolusFeatureFlag, ArbolusFeatureFlag>;

export enum FeatureFlagsAppType {
  CLIENT = "Client",
  ADMIN = "Admin"
}

/**
 * ConfigCat Feature Flag Names
 * Centralized constants for all feature flags used with ConfigCat
 * to avoid hardcoded strings throughout the codebase.
 * Add new flags here as you migrate them from the legacy system to ConfigCat.
 */
export const CONFIG_CAT_FLAGS = {
  // Common flags (used across multiple apps)
  COMMON: {},
  // Client-specific flags
  CLIENT: {
    BUTTON_TRACKED: "buttonTracked",
    CONVERSION_EXPERIMENT_REGISTRATION_HIDE_EMAIL_OPTION:
      "conversion_experiment_registration_hide_email_option",
    CONVERSION_OPS_CUSTOMER_CANOPY_AUTOMATED_MODAL:
      "conversion_ops_customer_canopy_automated_modal",
    CONVERSION_EXPERIMENT_SUGGESTED_ENGAGEMENTS:
      "conversion_experiment_suggested_engagements",
    CONVERSION_EXPERIMENT_SOFTWARE_REVIEWS_QUALITATIVE:
      "conversion_experiment_software_reviews_qualitative",
    ACQUISITION_EXPERTS_REFERRED_PAGE: "acquisition_experts_referred_page",
    ACQUISITION_EXPERTS_SIMPLE_SIGN_UP: "acquisition_experts_simple_sign_up",
    ACQUISITION_EXPERTS_SIGN_UP_EMAIL: "acquisition_experts_sign_up_email",
    ACQUISITION_RELEASE_REFERRALS_APPLICATION_STEP:
      "acquisition_release_referrals_application_step",
    ACQUISITION_RELEASE_REFERRALS_SHARE_LINK:
      "acquisition_release_referrals_share_link",
    CONVERSION_RELEASE_SOFTWARE_REVIEWS_UPDATE:
      "conversion_release_software_reviews_update"
  },
  // Admin-specific flags
  ADMIN: {
    GROWTH_RELEASE_CLIENT_SOFTWARE_REVIEW_REQUEST:
      "growth_release_client_software_review_request"
  }
} as const;

// Type-safe access to all flag names
export type ConfigCatFlagName =
  | (typeof CONFIG_CAT_FLAGS.COMMON)[keyof typeof CONFIG_CAT_FLAGS.COMMON]
  | (typeof CONFIG_CAT_FLAGS.CLIENT)[keyof typeof CONFIG_CAT_FLAGS.CLIENT]
  | (typeof CONFIG_CAT_FLAGS.ADMIN)[keyof typeof CONFIG_CAT_FLAGS.ADMIN];
